import React from "react";
import $ from 'jquery'

const YEARLY_DISCOUNT = "YearlyDiscount"

export default class OrderSummary extends React.Component{

  /* istanbul ignore next */
  fixOrderSummary(mobile){
    if(mobile === false){
      $(window).scroll(function(){
        if( $(window).scrollTop() > 150 ) {
          $('#order-summary').css({position: 'fixed',top:'5px','margin-top':'0px'});
        } else {
          $('#order-summary').css({position: 'relative','margin-top':'100px'});
        }
      });
    }else{
      $('#order-summary').css({position: 'relative','margin-top':'10px'});
    }
  }

  /* istanbul ignore next */
  orderDiscount(){
    var discount = 0
    var quotes = this.props.quotes
    let yearlyCoupon = this.props.isYearlyCouponApplied()

    if(quotes!==null){
      for(var index = 0; index < quotes.length; index++){
        if (yearlyCoupon) {
          discount = discount + quotes[index].yearlyDiscount
        } else {
          discount = discount + quotes[index].discount
        }

      }
    }

    if(this.props.order.quotes && this.props.order.quotes.cartDiscount !== null){
      discount = discount + this.props.order.quotes.cartDiscount
    }
    return discount;
  }

  /* istanbul ignore next */
  pricingFormat(value){
    var parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }

  componentDidMount() {
    var mobile = false
    if(/Android|webOS|iPhone|iPod|ipad|BlackBerry/i.test(navigator.userAgent) ){
      mobile = true
    }
    window.addEventListener('scroll',this.fixOrderSummary(mobile));
  }

  render(props){
    return (
      <div id="order-summary" className="margin-top-100 order-summary" ref={this.orderSummaryDetails}>
        <div className="order-header registration-h6">ORDER SUMMARY</div>

        {
          this.props.quotes !== undefined && this.props.quotes.length > 0 &&
          <div>
            {
              this.props.quotes.map(function(item, index){
                return(
                  <div className="row margin-top-10" key={index}>
                    <div className="col-xs-8 margin-top-5">
                      <div className="item-header-checkout registration-h6 "> {item.headline} </div>
                      <div className="order-item footnote-text ">
                        {
                          item.lineItems && item.lineItems.map(function(lineItem, subIndex){
                            return(
                              <span key={subIndex}>{lineItem.description}
                                {
                                  subIndex < item.lineItems.length-1 &&
                                  <span>, <br/></span>
                                }
                              </span>
                            )
                          })
                        }
                      </div>
                      {
                        item.addons && item.addons.length > 0 &&
                        <div className="row no-margin">
                          <div className="item-header captions" style={{marginTop:"8px"}}>{item.addons.length} Add-ons </div>
                          <div className="order-item footnote-text ">
                            {
                              item.addons.map(function(lineItem, subIndex){
                                return(
                                  <div key={subIndex}>{lineItem.description}</div>
                                )
                              })
                            }
                          </div>
                        </div>
                      }
                    </div>
                    <div className="col-xs-4 padding-5 text-right margin-top-5">
                      <div className="item-header-checkout registration-h6"> ${this.pricingFormat(item.originalPrice.toFixed(2))}</div>
                      <div className="order-items footnote-text">
                        {
                          item.totalPerMonth < 0.1 &&
                          <small className='text-right footnote-text checkout-small'>Min. cost for Trial Period</small>
                        }
                        {
                          item.totalPerMonth > 0.1 &&
                          <small className='text-right footnote-text checkout-small'>Min. cost ${this.pricingFormat((item.totalPerMonth * item.contractMonths).toFixed(2))} (incl. GST) over {item.userContractMonths} month(s).</small>
                        }
                      </div>

                    </div>
                  </div>
                )
              }.bind(this))
            }
          </div>
        }
        <hr/>
        {
          this.props.order &&
          <div className="row">
            <div className="col-sm-12">
              <div className="row">
                <div className="col-xs-8">
                  <div className="text-left registration-h6">Items incl. GST</div>
                </div>
                <div className="col-xs-4">
                  <div className="text-right registration-h6">${this.pricingFormat(parseFloat(this.props.originalTotalPrice).toFixed(2))}</div>
                </div>
              </div>
              {
                (this.orderDiscount() > 0) &&
                <div className="row">
                  <div className="col-xs-8">
                    <div className="text-left success-text registration-h6">
                      Discount
                    </div>
                  </div>
                  <div className="col-xs-4">
                    {
                      this.orderDiscount() > 0 &&
                      <div className="text-right success-text registration-h6">-${this.orderDiscount().toFixed(2)}</div>
                    }
                  </div>
                </div>
              }
              <div className="row">
                <div className="col-xs-7">
                <div className="text-left registration-h5" >
                  { this.props.isYearlyCouponApplied() ? "Total Upfront Cost" : "Total Monthly Cost"}</div>
                </div>
                <div className="col-xs-5">
                  <div className="text-right registration-h5" >${this.pricingFormat(this.props.totalPrice.toFixed(2))}
                    {
                      this.props.totalPrice === 0 &&
                      <p className="no-margin checkout-small">Trial Period</p>
                    }
                  </div>
                  <div className="footnote-text">
                    {
                      this.props.totalPrice > 0 &&
                      <div className="text-right footnote-text checkout-small">Min. cost ${this.pricingFormat((this.props.minCost).toFixed(2))} over {this.props.userTotalMonths} month(s).</div>
                    }
                    {
                      this.props.totalPrice === 0 &&
                      <div className="text-right footnote-text checkout-small">Min. cost for Trial Period.</div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        {
          this.props.order && <>
            <hr/>
            {
              this.props.totalPrice === 0 &&
              <div className="row">
                <div className="col-xs-12">
                    <div className="footnote-text checkout-small">The Trial Period will vary at the discretion of your Cotality Salesperson, not to exceed 7 days.</div>
                </div>
              </div>
            }
          </>
        }
      </div>
    )
  }
}
